import axios from 'axios'
import { environment } from '../config.env';

const ENDPOINT_DOMAIN = process.env.REACT_APP_ENDPOINT_DOMAIN || environment.endpoint_domain || ''

axios.defaults.baseURL = ENDPOINT_DOMAIN;
// axios.defaults.headers.common['Authorization'] = localStorage.getItem('pg_access_token');

//manage
export function ManagegetBoard(page, number_per_page) {
    return new Promise(resolve => {
        const path = '/api/v1/board/manage/getBoard'
        let header = {
            'Content-Type': 'application/json',
            'Authorization': localStorage.getItem('pg_access_token')
        }
        axios.get(path, { headers: header }).then(res => {
            resolve(res)
        }).catch((error) => {
            resolve(false)
            //console.log(error)
        })
    })
}

export function ManageremoveBoard(board_id) {
    return new Promise(resolve => {
        const path = '/api/v1/board/manage/removeBoard'
        let body = {
            "board_id": board_id
        }
        let header = {
            'Content-Type': 'application/json',
            'Authorization': localStorage.getItem('pg_access_token')
        }
        axios.post(path, body, { headers: header }).then(res => {
            resolve(res)
        }).catch((error) => {
            resolve(false)
            //console.log(error)
        })
    })
}

export function ManagesaveComment(board_id, comment_detail, show_name, attachment_list) {
    return new Promise(resolve => {
        const path = '/api/v1/board/manage/saveComment'
        let body = {
            "board_id": board_id,
            "comment_detail": comment_detail,
            "show_name": show_name,
            "attachment_list": []
        }
        let header = {
            'Content-Type': 'application/json',
            'Authorization': localStorage.getItem('pg_access_token')
        }
        axios.post(path, body, { headers: header }).then(res => {
            resolve(res)
        }).catch((error) => {
            resolve(false)
            //console.log(error)
        })
    })
}

//view
export function ViewgetBoard(page, number_per_page) {
    return new Promise(resolve => {
        const path = '/api/v1/board/view/getBoard'
        let body = {
            "page": page,
            "number_per_page": number_per_page
        }
        let header = {
            'Content-Type': 'application/json',
            'Authorization': localStorage.getItem('pg_access_token')
        }
        axios.post(path, body, { headers: header }).then(res => {
            resolve(res)
        }).catch((error) => {
            resolve(false)
            //console.log(error)
        })
    })
}

export function ViewgetBoardData(board_id) {
    return new Promise(resolve => {
        const path = '/api/v1/board/view/getBoardData'
        let body = {
            "board_id": board_id
        }
        let header = {
            'Content-Type': 'application/json',
            'Authorization': localStorage.getItem('pg_access_token')
        }
        axios.post(path, body, { headers: header }).then(res => {
            resolve(res)
        }).catch((error) => {
            resolve(false)
            //console.log(error)
        })
    })
}